import { createFileRoute } from '@tanstack/react-router'
import { AccountMappingSection } from '../../../features/settings/account-mapping-section'
import { requireSection } from '../../../features/settings/guards'

export const Route = createFileRoute('/_app/settings/account-mapping')({
  staticData: { crumb: 'settingsSection' },
  beforeLoad: ({ context }) => requireSection(context.session, 'account-mapping'),
  component: AccountMappingSection,
})
